module.exports = __webpack_public_path__ + "img/cube-primary.48e573cd.svg";